export default __webpack_public_path__ + "static/media/sydney.befb0c77.png";